/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable max-len */
import React, {
  useEffect, useRef, useState,
} from 'react';
import Link from 'next/link';

import { useRouter } from 'next/router';
import PageHeader from '../shared/PageHeader';
import FilterBottomSheet from '../filterBottomSheet/FilterBottomSheet';
import { getCurrentOrgName } from '../../utils/helpers';
// import Spinner from '../../icons/spinner';
import CourseTags from './courseTags';
import CourseList from './courseList';
import TagView from '../shared/tagView';
import TestSeriesCard from '../test-series/mock-test/mocktest-listing/test-series-card';
import { trackEvent } from '../../utils/analytics';
import { useFirebase } from '../../contexts/ssr-firebase-context';
import { useUser } from '../../contexts/ssr-user-context';
import CopyDeeplink from '../shared/CopyDeeplink';

function AllCoursesList() {
  const router = useRouter();
  //   const searchParams = router.query;
  const { user: loggedInUser } = useUser();

  // is this a feature request as to apply user stream id as default filter for courses and test series if not present in url query params
  const [userStreamId, setUserStreamId] = useState(loggedInUser?.profile?.accountDetails?.streamId);
  const [queryPareams, setQueryParams] = useState({
    streamId: loggedInUser?.profile?.accountDetails?.streamId || '',
    ...router.query,
  });

  // const [queryPareams, setQueryParams] = useState({});
  const [selectedTag, setSelectedTag] = useState('');
  const [isRefetch, setIsRefetch] = useState(false);
  const [clearFilter, setClearFilter] = useState(false);

  // serachbar functionality start
  const [searchTerm, setSearchTerm] = useState('');
  // const clearParams = () => window.history.pushState(null, '', window.location.origin + window.location.pathname);
  const clearParams = () => {
    router.replace(router.pathname, undefined, { shallow: true });
  };

  const clearParamsKeepScope = () => { // function for keep scope param
    const url = new URL(window.location.href);
    const scopeValue = router?.query?.scope || url.searchParams.get('scope');
    url.search = '';
    if (scopeValue) {
      url.searchParams.set('scope', scopeValue);
    }
    // window.history.pushState(null, '', url.toString());
    router.replace(url.toString(), undefined, { shallow: true });
  };

  const [expanded, setExpanded] = useState();
  const inputRef = useRef();
  const wrapperRef = useRef(null);
  const [MobileExpandClass, setMobileExpandClass] = useState(false);

  const [tagName, setTagName] = useState(router.query.scope || 'Courses');
  const [type, setType] = useState();
  const [page, setPageType] = useState();
  const orgName = getCurrentOrgName();
  const isMadeeasy = orgName === 'madeeasyprime' || orgName === 'madeeasy';
  const deeplinkBaseurl = isMadeeasy ? process.env.NEXT_PUBLIC_DEEPLINK_BASE_URL_MADEEASYPRIME : process.env.NEXT_PUBLIC_DEEPLINK_BASE_URL_NEXTIAS;
  const [coursePageFilters, setCoursePageFilters] = useState(null);
  const [coursePageTags, setCoursePageTags] = useState(null);
  const handleCoursePageFilters = (pageFilters) => {
    if (!coursePageFilters) {
      setCoursePageFilters(pageFilters || null);
    }
  };
  const handleCoursePageTags = (tags) => {
    setCoursePageTags(tags || null);
  };
  const handleCourseTag = (tagId) => {
    if (tagId === 'all') {
      setSelectedTag('');
    } else {
      setSelectedTag(tagId);
    }
    setSearchTerm(''); // clear search when
  };
  const [searchLoad, setsearchload] = useState(false);
  // apply filters function
  const handleApplyFilters = (filters) => {
    if (Object.keys(filters).length > 0) {
      const entries = Object.entries(filters);
      setSearchTerm('');
      setsearchload(true);
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of entries) {
        setQueryParams((prev) => ({
          ...prev, // previous state for open accordion
          [key]: value,
        }));
      }
      setTimeout(() => {
        setsearchload(false);
      }, 2000);
      // Clever tab Event
      trackEvent('Filter_Applied', {
        timestamp: new Date().getTime(),
        mode: filters?.mode,
        language: filters?.language,
        exam: filters?.examId,
        center: filters?.centreId,
        screenName: 'Test series',
      });
    } else {
      setClearFilter(true);
      setQueryParams({});
      setSelectedTag('');
    }

    setIsRefetch(true);
  };
  useEffect(() => {
    if (!clearFilter) {
      setQueryParams({
        coursescope: router.query.coursescope || '',
        mode: router.query.mode || '',
        centreId: router.query.centreId || '',
        tag: router.query.tag || '',
        examId: router.query.examId || '',
        language: router.query.language || '',
        streamId: router.query.streamId || userStreamId || '',
        type: router.query.type || '',
      });
      setUserStreamId(null);
      if (router?.query?.tag === 'all') {
        setSelectedTag('');
      } else {
        setSelectedTag(router.query.tag);
      }
    }

    const isTestSeries = router.query.scope === 'testseries';
    setTagName(isTestSeries ? 'testseries' : 'Courses');
    setType(isTestSeries ? 'testseries' : 'course');
    setPageType(isTestSeries ? 'testseries' : 'courses');
  }, [router.query]);

  // json for tab Data
  const ListJson = [{
    name: 'Courses',
  },
  { name: 'testseries' },
  ];

  useEffect(() => {
    if (tagName !== 'testseries' && queryPareams.streamId) {
      router.replace(
        {
          pathname: router.pathname,
          query: {
            ...router.query,
            streamId: queryPareams.streamId,
          },
        },
        undefined,
        { shallow: true },
      );
    }
    // if (queryPareams.streamId) {
    //   const url = new URL(window.location.href);
    //   url.searchParams.set('streamId', queryPareams.streamId);
    //   window.history.replaceState(null, '', url.toString());
    // }
  }, [queryPareams.streamId]);

  // Focus input when expanded on mobile
  useEffect(() => {
    if (expanded && inputRef.current) {
      inputRef.current.focus();
    }
  }, [expanded]);

  const clearSearch = () => {
    setSearchTerm('');
    // setExpanded(false);
  };
  const clearFilterafterSeacrh = () => {
    setClearFilter(true);
    setQueryParams({});
    setSelectedTag('');
    // clearParams();
    if (router.query.scope || new URL(window.location.href).searchParams.get('scope')) {
      clearParamsKeepScope();
    } else {
      clearParams();
    }
  };
  const handleTabClick = (tag) => {
    setTagName(tag.name || tag);
    setType(tag.name === 'Courses' ? 'course' : tag.name); // recheck
    setPageType(tag.name.toLowerCase());
    setClearFilter(true);
    setSelectedTag('');
    setQueryParams({});
    setUserStreamId(null);
    console.log('queryPareams', queryPareams);
    const scope = tag.name;
    const newUrl = {
      pathname: router.pathname,
      query: { scope },
    };

    // Replace URL without reloading or losing scroll
    router.replace(newUrl, undefined, { shallow: true });
  };

  // for mobile searchicon click
  const mobilesearchIcon = () => {
    if (expanded) {
      setExpanded(false);
      setMobileExpandClass(false);
      setSearchTerm('');
    } else {
      setExpanded(true);
      setMobileExpandClass(true);
    }
  };

  // Testseries check
  const { getConfigValue } = useFirebase();
  const [testSeriesCheck, setTestseriesCheck] = useState();
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV === 'PROD') {
      setTestseriesCheck(getConfigValue('isTestSeriesLive'));
    } else {
      setTestseriesCheck(true);
    }
  }, []);

  const CoursecomponentsMap = {
    Courses: <CourseList user={loggedInUser} onPageFilters={handleCoursePageFilters} onPageTags={handleCoursePageTags} type={type} pageType={page} searchLoad={searchLoad} clearFilterafterSeacrh={clearFilterafterSeacrh} searchKey={searchTerm} isRefetch={isRefetch} queryPareams={queryPareams} queryPareamsTag={selectedTag} setSelectedTag={setSelectedTag} clearFilter={clearFilter} />,
    testseries: <TestSeriesCard onPageFilters={handleCoursePageFilters} onPageTags={handleCoursePageTags} type={type} pageType={page} searchLoad={searchLoad} clearFilterafterSeacrh={clearFilterafterSeacrh} searchKey={searchTerm} isRefetch={isRefetch} queryPareams={queryPareams} queryPareamsTag={selectedTag} setSelectedTag={setSelectedTag} clearFilter={clearFilter} selectTestTab={tagName} pageTypeParam="Allcourse" />,
  };

  // if (loading) return null;

  return (
    <div className="w-full h-full mx-auto lg:bg-[#f7f8fa]">
      { router.query.tag && router.query.examId && <CopyDeeplink link={`${deeplinkBaseurl}/${tagName.toLowerCase() === 'testseries' ? 'testseries' : 'courses'}/${router.query.tag}/${router.query.examId}`} />}
      <div className="mx-auto  container">
        <div className={`header justify-between px-4 items-center ${!MobileExpandClass ? 'flex' : 'block'}`}>
          <div className={`${expanded ? 'hidden lg:flex' : 'flex'} justify-between w-full`}>
            <PageHeader
              pageHeading="All Courses"
              breadCrumb={(
                <span>
                  <Link href="/home">Home</Link>
                  {' '}
                  /
                  {' '}
                  <span className="text-gray-700">Courses</span>
                </span>
    )}
            />

            {/* {!expanded && ( */}

            <button type="button" className="lg:hidden block" onClick={() => mobilesearchIcon()} aria-label="Toggle Search">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.5 18C14.6421 18 18 14.6421 18 10.5C18 6.35786 14.6421 3 10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18Z" stroke="#0F172A" strokeWidth="1.2" />
                <path d="M21 21L15.8025 15.8025" stroke="#0F172A" strokeWidth="1.2" />
              </svg>
            </button>
            {/* )} */}
          </div>
          <div className={`${!MobileExpandClass ? '' : 'mb-3'} ${expanded ? 'flex' : 'hidden lg:flex'} lg:w-full lg:max-w-[372px] relative lg:mt-0 mt-4 justify-between items-center`}>
            <span onClick={() => mobilesearchIcon()} className="lg:hidden cursor-pointer">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.125 13.125H23.625C23.8571 13.125 24.0796 13.2172 24.2437 13.3813C24.4078 13.5454 24.5 13.7679 24.5 14C24.5 14.2321 24.4078 14.4546 24.2437 14.6187C24.0796 14.7828 23.8571 14.875 23.625 14.875H6.125C5.89294 14.875 5.67038 14.7828 5.50628 14.6187C5.34219 14.4546 5.25 14.2321 5.25 14C5.25 13.7679 5.34219 13.5454 5.50628 13.3813C5.67038 13.2172 5.89294 13.125 6.125 13.125Z" fill="black" />
                <path d="M6.48735 14L13.7446 21.2555C13.9089 21.4198 14.0012 21.6426 14.0012 21.875C14.0012 22.1074 13.9089 22.3302 13.7446 22.4945C13.5803 22.6588 13.3575 22.7511 13.1251 22.7511C12.8927 22.7511 12.6699 22.6588 12.5056 22.4945L4.6306 14.6195C4.54911 14.5382 4.48446 14.4417 4.44035 14.3354C4.39624 14.2291 4.37354 14.1151 4.37354 14C4.37354 13.8849 4.39624 13.7709 4.44035 13.6646C4.48446 13.5583 4.54911 13.4618 4.6306 13.3805L12.5056 5.5055C12.6699 5.3412 12.8927 5.24889 13.1251 5.24889C13.3575 5.24889 13.5803 5.3412 13.7446 5.5055C13.9089 5.6698 14.0012 5.89264 14.0012 6.125C14.0012 6.35736 13.9089 6.5802 13.7446 6.7445L6.48735 14Z" fill="black" />
              </svg>
            </span>
            <div ref={wrapperRef} className="relative w-[90%] lg:w-full">
              <input
                ref={inputRef}
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full text-[#9D9D9D] text-sm border py-[10px] pl-8 pr-3 rounded-lg border-formFieldBlue focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-blue-300"
              />

              <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-[#9D9D9D]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>

              {/* Clear Icon (right) */}
              {searchTerm && (
              // eslint-disable-next-line jsx-a11y/control-has-associated-label
              <button
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-black"
                onClick={clearSearch}
                aria-label="Clear Search"
              >
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.191016 8.88671C-0.0636719 9.14141 -0.0636719 9.55428 0.191016 9.80898C0.445703 10.0637 0.858643 10.0637 1.11333 9.80898L0.191016 8.88671ZM5.46114 5.46114C5.71584 5.20644 5.71584 4.79357 5.46114 4.53888C5.20644 4.28418 4.79357 4.28418 4.53888 4.53888L5.46114 5.46114ZM4.53888 4.53888C4.28418 4.79357 4.28418 5.20644 4.53888 5.46114C4.79357 5.71584 5.20644 5.71584 5.46114 5.46114L4.53888 4.53888ZM9.80898 1.11333C10.0637 0.858644 10.0637 0.445703 9.80898 0.191016C9.55428 -0.0636719 9.14141 -0.0636719 8.88671 0.191016L9.80898 1.11333ZM5.46114 4.53888C5.20644 4.28418 4.79357 4.28418 4.53888 4.53888C4.28418 4.79357 4.28418 5.20644 4.53888 5.46114L5.46114 4.53888ZM8.88671 9.80898C9.14141 10.0637 9.55428 10.0637 9.80898 9.80898C10.0637 9.55428 10.0637 9.14141 9.80898 8.88671L8.88671 9.80898ZM4.53888 5.46114C4.79357 5.71584 5.20644 5.71584 5.46114 5.46114C5.71584 5.20644 5.71584 4.79357 5.46114 4.53888L4.53888 5.46114ZM1.11333 0.191016C0.858643 -0.0636719 0.445703 -0.0636719 0.191016 0.191016C-0.0636719 0.445703 -0.0636719 0.858644 0.191016 1.11333L1.11333 0.191016ZM1.11333 9.80898L5.46114 5.46114L4.53888 4.53888L0.191016 8.88671L1.11333 9.80898ZM5.46114 5.46114L9.80898 1.11333L8.88671 0.191016L4.53888 4.53888L5.46114 5.46114ZM4.53888 5.46114L8.88671 9.80898L9.80898 8.88671L5.46114 4.53888L4.53888 5.46114ZM5.46114 4.53888L1.11333 0.191016L0.191016 1.11333L4.53888 5.46114L5.46114 4.53888Z" fill="black" />
                </svg>
              </button>
              )}
            </div>
          </div>

        </div>
        <div className="flex flex-col sm:flex-col md:flex-col xl:flex-row lg:flex-row gap-6 lg:bg-[#f7f8fa] lg:ps-4 ps-0">
          <div className="w-full lg:block lg:w-1/3 lg:max-w-[320px]">
            <FilterBottomSheet
              filterData={coursePageFilters}
              isLoad={!coursePageFilters}
              onApplyFilters={handleApplyFilters}
              queryPareams={queryPareams}
            />
          </div>
          <div className="w-full lg:w-3/4 mr-2">
            <div className="w-full rounded-full">
              {
                testSeriesCheck && (
                <section className="bg-[#F1F8FF] lg:bg-transparent mb-4 lg:mb-5">
                  <TagView
                    tags={ListJson}
                    pageType="courseActive"
                    divClassName="pb-0"
                    liClassName="lg:w-auto w-1/2 lg:py-0 lg:pb-4 py-3 lg:after:bottom-[11px] after:bg-[#B9B9B9] after:bg-[#B8E5FF] after:h-[44%] before:bottom-0 before:right-0 before:w-full lg:px-3"
                    className="lg:w-auto w-full justify-center"
                    onTagClick={handleTabClick}
                    tagName={tagName}
                  />
                </section>
                )
}
              <section className="">
                <CourseTags tagsList={coursePageTags} queryPareamsTag={selectedTag} changeCourseTag={handleCourseTag} />
                {CoursecomponentsMap[tagName] || null}
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllCoursesList;
